import { Image, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { EProjectType } from '../../../enum/project';
import LogoMacraDesign from '../../../images/MacRA-Design_LOGO-Design_on-transp.png';
import { IProjectInfoForm } from '../../../pages/ProjectInfo/IProjectInfo';
import { styles } from '../PDFStyle';
import SVGLogo from './SVGLogo';

interface IPDFHeaderProps {
    projectInfo: IProjectInfoForm;
}

const PDFHeader = (props: IPDFHeaderProps) => {
    const { t, i18n } = useTranslation();
    return (
        <View style={styles.header} fixed>
            <View style={styles.borderBottom}>
                <View style={styles.flexColumn}>
                    <View style={styles.logo_title}>
                        <View style={styles.rowCentered}>
                            <Image src={LogoMacraDesign} style={styles.leftLogo} />
                            <Text style={styles.ms10}>| {props.projectInfo.type === EProjectType.Macra1 ? t('pdf_header_app_name') : t('project_type_structure')}</Text>
                        </View>
                        <SVGLogo />
                    </View>
                    <View style={styles.rowSpaced}>
                        <Text style={styles.subtitle}>{t('pdf_header_app_description')}</Text>
                        <Text style={styles.subtitle}>www.maccaferri.com</Text>
                    </View>
                </View>
            </View>
            <View style={styles.logo_title}>
                <Text style={styles.subtitle}>
                    {t('pdf_header_client')} <Text style={styles.boldGreen}>| {props.projectInfo.client}</Text>
                </Text>
                <Text style={styles.subtitle} render={({ pageNumber, totalPages }) => `pag. ${pageNumber} / ${totalPages}`} />
            </View>
        </View>
    );
};

export default PDFHeader;
